import * as consts from "./consts";
import axios from "axios";
import { CodeDetails, Settings, DefaultSettings } from "../types";

export const fetchCodeDetails = (
  currentThemeId: string,
  setCodeDetails: (codeDetails: CodeDetails) => void
): string => {
  let themeId = currentThemeId;
  let storageCodeDetails = localStorage.getItem(consts.STORAGE_CODE_DETAILS);
  if (storageCodeDetails) {
    let currentCodeDetails: CodeDetails = JSON.parse(storageCodeDetails);
    themeId = currentCodeDetails.themeId;
    setCodeDetails(currentCodeDetails);
  }
  return themeId;
};

export const sendPayForwardRequest = async (
  stage1Code: string,
  stage1Email: string,
  stage1Name: string,
  stage2Email: string,
  stage2From: string,
  stage2To: string,
  stage2Message: string
): Promise<boolean> => {
  let response = await axios.post(`${consts.SERVICE_URL}/specialprograms/cn`, {
    stage1Code: stage1Code,
    stage1Email: stage1Email,
    stage1Name: stage1Name,
    stage2Email: stage2Email,
    stage2From: stage2From,
    stage2To: stage2To,
    stage2Message: stage2Message,
  });
  return response.data;
};

export const clearCookies = async (): Promise<boolean> => {
  localStorage.removeItem(consts.STORAGE_CODE_DETAILS);
  localStorage.removeItem(consts.STORAGE_DONATIONS);
  localStorage.removeItem(consts.STORAGE_CHECKOUT);
  return true;
};
